<template>
  <div class="select_option">
    <div class="left">
      <Avatar class="disabled_avatar" :src="$store.state.headUrl + avatar" slot="prefix" size="30" />
      <span class="names">{{showName}}</span>
      <span class="hasFamily" v-if="hasChoosed">{{hasName}}</span>
    </div>
    <div class="right">{{username}}</div>
</div>
</template>

<script>
export default {
  name:'selectOption',
  props:{
    avatar:{
      type:String,
      default:'-1'
    },
    showName:{
      type:String,
      default:'-1'
    },
    // 邮箱
    username:{
      type:String,
      default:'-1'
    },
    // 是不是不可选状态
    hasChoosed:{
      type:Boolean,
      default:false
    },
    //不可选状态文字，列：已有家庭
    hasName:{
      type:String,
      default:'-1'
    }
  }
}
</script>

<style lang="stylus" scoped>
.select_option
  display flex
  justify-content space-between
  align-items center
  width 100%
  .names
    padding 12px
  .hasFamily
    color #FCBD44
    font-size 12px
</style>


// WEBPACK FOOTER //
// src/components/selectOption.vue